export function SectionHeader({
  subtitle,
  header,
  description,
}: {
  subtitle: string;
  description: string;
  header: string;
}) {
  return (
    <div className="mb-10 pt-6 border-b border-slate-200 pb-8">
      {subtitle && (
        <p className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-2">
          {subtitle}
        </p>
      )}
      <h2 className="text-3xl font-bold text-slate-900">{header}</h2>
      {description && (
        <p className="mt-3 text-slate-600 leading-relaxed max-w-2xl">
          {description}
        </p>
      )}
    </div>
  );
}
